<template>
  <Modal title="详情" v-model="visible" width="90%" class="my-modal top" :mask-closable="false" :footer-hide="true">
    <Spin size="large" fix v-if="detailLoading"></Spin>
    <div v-if="detailData" class="page-form">
      <Form :model="detailData" ref="formValidate" class="page-form" :label-width="100">
        <FormItem label="IFA姓名" prop="name"> {{ detailData.englishName ? detailData.englishName + '/' : '' }}{{ detailData.name }} </FormItem>
        <FormItem label="所属团队" prop="groupName">
          {{ detailData.groupName || '-' }}
        </FormItem>
        <FormItem label="入职时间" prop="entryTime">
          {{ formatDate(detailData.entryTime) }}
        </FormItem>
        <FormItem label="回溯自然年" prop="year"> {{ detailData.year }}年</FormItem>
        <FormItem label="自然年标保" prop="fee"> {{ formatNumber(detailData.fee) }}美元 </FormItem>
        <FormItem label="回溯状态" prop="backStatus">
          <Tag color="success" v-if="detailData.backStatus == '1' || detailData.backStatus == 1">回溯成功</Tag>
          <Tag color="error" v-else-if="detailData.backStatus == '0' || detailData.backStatus == 0">回溯失败</Tag>
        </FormItem>
      </Form>
    </div>
    <div class="modal-content" v-if="detailData && !detailLoading">
      <div class="policy-section">
        <div class="section-title">保单明细</div>
        <Table :columns="policyColumns" :data="policyList" border max-height="600">
          <template slot-scope="{ row }" slot="productType">
            <lzDicTxt dicType="PRODUCT_TYPE2" :dicCode="row.productType" />
          </template>
          <template slot-scope="{ row }" slot="name"> {{ row.name }}/{{ row.insuranceName }} </template>
          <template slot-scope="{ row }" slot="fee">
            <span>{{ row.fee }}</span>
            <lzDicTxt dicType="CURRENCY_INT" :dicCode="row.currencyType" />
            <span>/{{ row.paymentPeriod }}</span>
            <lzDicTxt v-if="row.paymentType" dicType="GUARANTEE_TYPE" :dicCode="row.paymentType" />
          </template>
        </Table>
      </div>
    </div>
  </Modal>
</template>

<script>
import dayjs from 'dayjs';
import lzDicTxt from '@/components/commons/lzDicTxt';

export default {
  name: 'DetailModal',
  components: {
    lzDicTxt
  },
  props: {
    userList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      detailData: null,
      detailLoading: false,
      // 保单列表数据（从详情接口返回的policyList字段中提取）
      policyList: [],
      // 保单表格列配置 - 严格按照图二定义的字段
      policyColumns: [
        { title: '保单编号', key: 'policyNo', align: 'center', minWidth: 140 },
        { title: '保司', key: 'companyName', align: 'center', minWidth: 90 },
        { title: '险种', slot: 'productType', align: 'center', minWidth: 120 },
        { title: '产品名称', key: 'productName', align: 'center', minWidth: 150 },
        { title: '投保人/受保人', slot: 'name', align: 'center', minWidth: 150 },
        { title: '年缴保费/缴费期', slot: 'fee', align: 'center', minWidth: 180 },
        { title: '标保(美元)', key: 'foldFyb', align: 'center', width: 130 },
        {
          title: '签单日期',
          key: 'signDate',
          align: 'center',
          width: 110,
          render: (h, params) => h('span', {}, params.row.signDate ? dayjs(params.row.signDate).format('YYYY-MM-DD') : '-')
        },
        {
          title: '冷静期截止日',
          key: 'expirationDate',
          align: 'center',
          width: 130,
          render: (h, params) => h('span', {}, params.row.expirationDate ? dayjs(params.row.expirationDate).format('YYYY-MM-DD') : '-')
        }
      ]
    };
  },

  methods: {
    /**
     * 打开详情弹窗
     * 通过GET请求调用详情接口获取完整数据
     * @param {Object} row - 行数据（至少包含id）
     */
    open(row) {
      this.visible = true;
      this.detailData = null;
      this.policyList = [];
      this.fetchDetail(row.id);
    },

    /**
     * 调用详情接口
     * GET /buz/userActiveRecord/read/detail?id=xxx
     * @param {number} id - 记录ID
     */
    fetchDetail(id) {
      this.detailLoading = true;

      console.log('[DetailModal] 请求详情接口, ID:', id);

      // GET请求，参数为id
      this.$http({
        url: '/buz/userTraceback/read/detail',
        type: 'GET',
        data: { id }
      })
        .then(res => {
          this.detailLoading = false;
          console.log('[DetailModal] 详情接口响应:', res);

          if (res.httpCode === 1) {
            // 设置详情数据（图一中的所有字段）
            this.detailData = res.data || null;

            // 从详情数据的policyList字段中提取保单列表（图二）
            if (this.detailData && this.detailData.policyList) {
              this.policyList = this.detailData.policyList;
              console.log('[DetailModal] 提取保单列表成功，共', this.policyList.length, '条');
            } else {
              this.policyList = [];
              console.log('[DetailModal] 无保单数据');
            }
          } else {
            this.$notice.msg(res.msg || '获取详情失败');
          }
        })
        .catch(err => {
          this.detailLoading = false;
          console.error('[DetailModal] 详情接口异常:', err);
          this.$notice.msg('获取详情失败，请稍后重试');
        });
    },

    /**
     * 格式化日期（只显示年月日）
     */
    formatDate(dateStr) {
      if (!dateStr) return '-';
      return dayjs(dateStr).format('YYYY-MM-DD');
    },

    /**
     * 格式化数字
     */
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '0.00';
      const num = Number(value);
      if (isNaN(num)) return '0.00';
      return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  padding-left: 10px;
  border-left: 3px solid #2d8cf0;
}
</style>
